export default __webpack_public_path__ + "static/media/SAS0300.34I-41715_-25009_0.cd8125f1.jpg";